/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: soundManager.ts
 *
 * Written by Yuliyan Milenkov <yuliyan.milenkov@egt-digital.com> on  28.10.22 2:35 pm.
 * Last modified: 28.10.22 2:35 pm.
 *
 * More information at: https://egt-digital.com/
 */
import { Howl, HowlOptions } from 'howler';
import { take } from 'rxjs';
import { addBuildHash } from './api/helpers';
import { soundSprites } from './constants';
import store from './eventStore';

const options: HowlOptions = {
    src: ['../assets/portal/sounds/portalSounds.mp3'],
    volume: 1,
    preload: true,
    sprite: soundSprites,
};

Howler.autoSuspend = false;
Howler.autoUnlock = true;

let currentHost: string = '';
let shouldStop: boolean = true;

export let soundManager: Howl | null;

store.INITIALIZE_SOUNDS.pipe(take(1)).subscribe(() => {
    const settings = store.SETTINGS.value;

    if (settings.host !== currentHost) {
        currentHost = settings.host;
    }

    options.src = [addBuildHash(`${currentHost}/assets/portal/sounds/portalSounds.mp3`)];
    soundManager?.mute();
    soundManager?.unload();
    soundManager = new Howl(options);
});

const startGameSubscription = store.START_GAME.subscribe(() => {
    store.ON_PLAY_SOUND.next('selectGameSound');
});

const hoverGameSubscription = store.HOVER_GAME.subscribe(() => {
    store.ON_PLAY_SOUND.next('hoverSound');
});

const onPlaySubscription = store.ON_PLAY_SOUND.subscribe(soundId => {
    if (soundId === 'selectGameSound') {
        shouldStop = false;
    }
    if (shouldStop) {
        soundManager?.stop();
    }
    if (!store.ON_SOUND_MUTED.value) {
        soundManager?.play(soundId);
    }
});

export const setAudioManagerShouldStop = (value: boolean) => {
    shouldStop = value;
};

const onSelectCategorySubscription = store.SELECT_CATEGORY.subscribe(() => {
    store.ON_PLAY_SOUND.next('selectTabSound');
});

export const subscriptions = {
    startGame: startGameSubscription,
    hoverGame: hoverGameSubscription,
    onPlay: onPlaySubscription,
    onSelectCategory: onSelectCategorySubscription,
};
